import Cookies from 'js-cookie'
import { isInTelegramWebApp } from '@/utils/telegram';
const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey);

  // ✅ 判断是否在 Telegram Mini App 中
  if (isInTelegramWebApp()) {
    window.Telegram.WebApp.close(); // 关闭 Mini App
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js